<template>
  <label for="branches-multiselect-component" class="form-label">
    {{ $t('branch.list') }}
  </label>
  <TomSelect
    v-model="componentValue.selectedBranches"
    :options="{
      create: false,
      placeholder: $t('branch.selectMore')
    }"
    class="w-full"
    multiple
  >
    <option v-for="branch in branches" :value="branch.uuid" :key="branch.uuid">
      {{ branch.title }}
    </option>
  </TomSelect>
</template>

<script>
import { defineComponent, computed } from 'vue'
import branchApi from '../../services/branches/branch.api'

export default defineComponent({
  data() {
    return {
      branches: []
    }
  },
  mounted() {
    branchApi.getList(1, 100).then(
      response => {
        this.branches = response.data.data
      },
      error => {
        alert(error)
      }
    )
  },
  props: {
    selectedBranches: {
      type: Object,
      default: () => {}
    }
  },

  emits: ['update:selectedBranches'],

  setup(props, { emit }) {
    const componentValue = computed({
      get: () => props.selectedBranches,
      set: value => emit('update:selectedBranches', value)
    })

    return {
      componentValue
    }
  }
})
</script>
